import { ITravelHotelSubBooking } from '@shared/shared/interfaces/travel-hotel.interfaces';
import { HOTEL_SUB_BOOKING } from 'app.config';
import * as fromActions from '../actions/travel-hotel-sub-booking.actions';

export const initialState: ITravelHotelSubBooking = {
  amount_paid: '',
  amount_paid_currency: '',
  amount_to_pay_at_hotel: '',
  amount_to_pay_at_hotel_currency: '',
  average_nightly_rate: '',
  average_nightly_rate_currency: '',
  cancellation_policies: [],
  cancellation_policy: '',
  check_in_date: '',
  check_in_instructions: '',
  check_out_date: '',
  duration_of_stay: null,
  extra_due_at_hotel: '',
  extra_due_at_hotel_currency: '',
  hotel: {},
  hotel_search_room_result: null,
  id: null,
  display_installments_contact_banner: false,
  is_benefits_room_booking: false,
  number_of_guests: null,
  number_of_rooms: null,
  pay_local_selected: false,
  room_description: '',
  room_type: '',
  hotelSupplier: '',
  supplier: '',
  taxes_and_fees: '',
  taxes_and_fees_currency: '',
  terms: {
    text: [],
    popups: [],
    links: [],
  },
  terms_and_conditions: '',
  total_price: '',
  total_price_currency: '',
  travellers: [],
  url: '',
  start_date: '',
  end_date: '',
  hotel_ivector_connect_id: '',
  room_requests: null,
  travellerPatch: {
    loading: false,
    loaded: false,
    error: null,
  },
};

export function reducer(
  state = initialState,
  action: fromActions.TravelHotelSubBookingActions
): ITravelHotelSubBooking {
  switch (action.type) {
    case fromActions.CLEAR_HOTEL_SUB_BOOKING:
      localStorage.removeItem(HOTEL_SUB_BOOKING);
      return initialState;

    case fromActions.VIEW_HOTEL_SUB_BOOKING_SUCCESS:
    case fromActions.CREATE_HOTEL_SUB_BOOKING_SUCCESS: {
      const newState = {
        ...state,
        ...action.payload,
        error: null,
      };
      localStorage.setItem(HOTEL_SUB_BOOKING, JSON.stringify(newState));
      return newState;
    }
    case fromActions.CREATE_HOTEL_SUB_BOOKING_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case fromActions.PATCH_HOTEL_SUB_BOOKING_TRAVELLERS:
      return {
        ...state,
        travellerPatch: {
          loading: true,
          loaded: false,
          error: null,
        },
      };
    case fromActions.PATCH_HOTEL_SUB_BOOKING_TRAVELLERS_SUCCESS:
      return {
        ...state,
        travellers: action.payload.traveller_names,
        travellerPatch: {
          loading: false,
          loaded: true,
          error: null,
        },
      };
    case fromActions.PATCH_HOTEL_SUB_BOOKING_TRAVELLERS_FAILURE:
      return {
        ...state,
        travellerPatch: {
          loading: false,
          loaded: false,
          error: action.payload,
        },
      };
    case fromActions.CLEAR_HOTEL_TRAVELLER_PATCH:
      return {
        ...state,
        travellerPatch: {
          loading: false,
          loaded: false,
          error: null,
        },
      };
    default:
      return state;
  }
}
